<template>
    <div class="login flex">

        <div class="main flex">
            <div class="welcome">银联商务车安堡——运营端</div>
            <div class="login-box">
                <div class="title">登录账户</div>
                <el-form ref="form" :model="form" :rules="rules">
                    <el-form-item>
                        <el-input
                            placeholder="请输入用户名/手机号"
                            prefix-icon="el-icon-user"
                            v-model="form.mobile"
                            @keyup.enter.native="login" />
                    </el-form-item>
                    <el-form-item>
                        <el-input
                            :show-password="true"
                            type="password"
                            placeholder="请输入密码"
                            prefix-icon="el-icon-lock"
                            v-model="form.password"
                            @keyup.enter.native="login" />
                    </el-form-item>
                    <el-form-item prop="captcha">
                        <div class="flex">
                            <el-input
                            placeholder="请输入验证码"
                            v-model="form.captcha"
                            @keyup.enter.native="login"
                            />
                            <img class="code" :src="codeImg" alt="验证码" @click="getCode"/>
                        </div>
                    </el-form-item>
                </el-form>
                <div class="other flex">
                    <div class="forgot" @click="goResetPwd">忘记密码</div>
                </div>
                <el-button type="primary" class="loginBtn flex" @click="login">登录</el-button>
            </div>
        </div>

        <div class="beianArea flex">
            <div class="copyright">系统开发服务提供商：中保云（厦门）科技有限公司</div>
            <a class="beianNumber" href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">
                闽ICP备2023004278号-1
            </a>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            form: {
                mobile: '',
                password: '',
                key: '',
                captcha: '',
            },
            rules: {
                mobile: [{
                    required: true, message: '请输入登录账户', trigger: 'blur'
                }],
                password: [{
                    required: true, message: '请输入密码', trigger: 'blur'
                }],
                captcha: [{
                    required: true, message: '请输入验证码', trigger: 'blur'
                }]
            },
            codeImg: '',


        }
    },
    created() {
        this.getCode();
    },
    methods: {
        getCode(){
            this.$http.get(this.common.admin + '/api/captcha').then(res => {
                if(res.code === 200){
                    this.form.key = res.data.key;
                    this.codeImg = res.data.img;
                }else{
                    return this.$message.error(res.msg);
                }
            });
        },
        login(){
            this.$refs.form.validate((valid) => {
                if (valid) {
                    if(!this.form.key){
                        return this.$message.error('获取登录key失败，请刷新页面重试');
                    }
                    this.$http.post(this.common.admin + '/admin/login', this.form).then(res => {
                        if(res.code === 200){
                            this.$store.commit('setToken', res.data.api_token);
                            // localStorage.setItem('token', res.data.api_token);
                            localStorage.removeItem('userType');
                            let userType = '';
                            if(res.data.is_admin == 1){
                                userType = 'superadmin';
                            }else{
                                userType = 'admin';
                            }
                            localStorage.setItem('userType', userType);
                            let info = JSON.stringify(res.data);
                            localStorage.setItem('userInfo', info);

                            //针对单个用户权限(临时注释掉)
                            // this.$store.commit('setTag', {
                            //     name: '运营账号管理',
                            //     path: {path: '/main/operationAccount'},
                            // });
                            this.$message.success('登录成功');
                            

                            //针对单个用户权限(临时)
                            // let userInfo = JSON.parse(localStorage.getItem('userInfo'));
                            if(JSON.parse(info).account === '15980832021'){
                                this.$router.push({
                                    path: '/main/stationGroup'
                                });
                                this.$store.commit('setTag', {
                                    name: '桩群管理',
                                    path: {path: '/main/stationGroup'},
                                });                                    
                            }
                            
                            if(JSON.parse(info).account !== '15980832021'){
                                this.$router.push({
                                    path: '/main/operationAccount'
                                });
                                this.$store.commit('setTag', {
                                    name: '运营账号管理',
                                    path: {path: '/main/operationAccount'},
                                });                                
                            }



                        }else{
                            this.getCode();
                            return this.$message.error(res.msg);
                        }
                    });
                } else {
                    this.getCode();
                    return this.$message.error('请检查输入的账号密码是否输入完整');
                }
            });
        },
        goResetPwd(){
            this.$router.push({
                path: '/forgotPwd_admin'
            });
        }
    },
}
</script>
<style lang="less" scoped>
    .login{
        position: relative;
        min-width: 1000px;
        height: 100%;
        min-height: 800px;
        background-image: url('./../assets/img/login_bg.png');
        background-size: 100% 100%;

        flex-direction: column;
        
        .main{
            flex: 1;
            // height: 100%;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            .welcome{
                margin-bottom: 30px;
                font-size: 30px;
                font-weight: bold;
                color: #FFF;
            }
            .login-box{
                padding: 50px 30px;
                width: 20%;
                min-width: 400px;
                background-color: #fff;
                border-radius: 18px;

                .title{
                    margin-bottom: 40px;
                    font-size: 24px;
                    color: #333;
                    text-align: center;
                }

                /deep/.el-input__inner{
                    height: 50px;
                    font-size: 16px;
                }
                .code{
                    margin-left: 2px;
                    width: 122px;
                    height: 48px;
                    border: 1px dashed #999;
                    border-radius: 4px;
                    cursor: pointer;
                }
            }

            .el-form{
                // margin-bottom: 60px;
            }
            .other{
                margin: 20px 0;
                justify-content: flex-end;
                .forgot{
                    font-size: 16px;
                    color: #989898;
                    cursor: pointer;

                    &:hover{
                        color: #7c7c7c;
                    }
                }
            }
            .loginBtn{
                // align-items: center;
                // justify-content: center;
                width: 100%;
                height: 50px;
                font-size: 18px;
                // background-color: #409eff;
                color: #fff;
                border-radius: 6px;
                cursor: pointer;
            }
        }

        .beianArea{
            width: 100%;
            height: 50px;
            // background-color: #fff;
            align-items: center;
            justify-content: center;

            flex-direction: column;
            .copyright{
                color: #fff;
                font-size: 14px;
            }

            .beianNumber{
                text-decoration: none;
                color: #fff;
                font-size: 14px;

                &:hover{
                    color: var(--main-theme-color);
                }
            }
        }
    }
</style>